// skipcq: JS-W1028
import React from 'react';

// theme
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { muiTheme } from './utils/theme';
import { initPostHog } from './utils/posthogClient';
// components
import { AppRoutes } from './routes/AppRoutes';

initPostHog();

function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <div className="App" style={{ minHeight: '100vh' }}>
        <AppRoutes />
      </div>
    </ThemeProvider>
  );
}

export default App;
